import React, {memo} from 'react';
import {qualitiesArray} from '@app/titles/models/qualities';
import {Lien} from '@app/titles/models/lien';
import {PlusOneIcon} from '@ui/icons/material/PlusOne';

interface LastLinkProps {
  item?: {
    nzb: number;
    episode_id: number;
    saison: number;
    episode: number;
    qualite: number;
  };
}

export const LastLink = memo(({item}: LastLinkProps) => {
  const qualities = {} as Record<number, string>;
  qualitiesArray.forEach(item => {
    qualities[item.id_qual] = item.qual;
  });
  return (
    <div className="text-gray-300 me-2 rounded bg-[#252529] px-4  py-2 text-xs font-medium">
      {item?.nzb && item?.nzb > 0 ? (
        <span style={{fontSize: '7px'}}>+NZB</span>
      ) : (
        <PlusOneIcon size="20" />
      )}{' '}
      {item?.saison && item?.episode
        ? 'S' + item?.saison + 'E' + item?.episode
        : item?.qualite && qualities[item?.qualite]}
    </div>
  );
});
